import { useCallback } from "react";
import { useModal } from "@racoon/ui";
import { CreateOrderDialogBody } from "./create-order-body.dialog";
import { CreateOrderHeading } from "../components/create-order-heading";
import { createOrderPicks } from "../model/order-picks";
import { orderFormBodyClass, orderFormModalShell } from "./order-form-styles";

export interface OpenCreateOrderOptions {
  preselectedLocationId?: string;
  preselectedLocationName?: string;
  preselectedLocationTariff?: number;
}

export function useCreateOrderDialog() {
  const { openModal, closeModal } = useModal();

  // Memoized: tables list openers among their column deps, and a new function
  // each render would rebuild the columns and remount every cell (hyperlinks
  // included) on every render.
  const openCreateOrder = useCallback(
    (options: OpenCreateOrderOptions = {}) => {
      const { preselectedLocationId, preselectedLocationName, preselectedLocationTariff } = options;

      // Use a ref-like container so the body closure can access the id after assignment.
      const idRef = { current: "" };
      const picks = createOrderPicks();

      idRef.current = openModal({
        ...orderFormModalShell,
        title: <CreateOrderHeading picks={picks} />,
        body: (
          <CreateOrderDialogBody
            onClose={() => closeModal(idRef.current)}
            onPicksChange={picks.set}
            preselectedLocationId={preselectedLocationId}
            preselectedLocationName={preselectedLocationName}
            preselectedLocationTariff={preselectedLocationTariff}
          />
        ),
        bodyClassName: orderFormBodyClass,
      });

      return idRef.current;
    },
    [openModal, closeModal],
  );

  return { openCreateOrder };
}
